import { Messages } from '~src/codegen/Localize';
import { RecommendationCard } from '~src/recommendations/components/cardView/RecommendationCard';
import { ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getGenericDefaultFilters } from '~src/spacesPlatform/contentDefinitions/getDefaultFilters';

export const RecommendedViewDefinition: ExplorableItemDefinition = {
  itemType: 'recommendedView',
  pluralName: Messages.recommendations,
  singularName: Messages.recommendation,
  emptyStateMessage: Messages.recommendationsEmptyMessage,
  contentFilterKeys: null,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: RecommendationCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => null,
  getContentInfo: () => {
  },
  supportedDisplayModes: ['thumbnail'],
};
